var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('li',{staticClass:"bgr-white"},[_c('a',{staticClass:"favorites",attrs:{"href":this.$root.fulldomain+'?favorites=1'}},[_vm._v(_vm._s(_vm.fav))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }